import * as React from 'react';

const EditIcon = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M16.7744 5.2729C16.7744 5.27293 16.7744 5.27288 16.7744 5.2729L15.2618 6.78549L17.7012 9.22483L19.2138 7.71224C19.2606 7.66536 19.287 7.60178 19.287 7.53549C19.287 7.46924 19.2607 7.4057 19.2138 7.35882M19.2138 7.35882L17.1279 5.2729C17.1279 5.27288 17.1279 5.27293 17.1279 5.2729C17.081 5.22609 17.0174 5.19971 16.9512 5.19971C16.8849 5.19971 16.8213 5.22609 16.7744 5.2729M16.6405 10.2855L14.2012 7.84615L5.70117 16.3462V18.7855H8.14051L16.6405 10.2855ZM15.7139 4.21208C16.0421 3.88401 16.4871 3.69971 16.9512 3.69971C17.4152 3.69971 17.8602 3.88401 18.1884 4.21208L20.2745 6.29816C20.6026 6.62634 20.787 7.07145 20.787 7.53549C20.787 7.99953 20.6027 8.44457 20.2746 8.77274L8.9815 20.0658C8.84085 20.2065 8.65008 20.2855 8.45117 20.2855H4.95117C4.53696 20.2855 4.20117 19.9497 4.20117 19.5355V16.0355C4.20117 15.8366 4.28019 15.6458 4.42084 15.5052L15.7139 4.21208Z"
      fill="#6B3EB4"
    />
  </svg>
);
export default EditIcon;
